const UNIQUE_CODE_COLLATOR = new Intl.Collator('es', {
  numeric: true,
  sensitivity: 'base',
});

/** Sort jewelry piece codes (e.g. `12/3`) by article then piece; fallback to locale collator. */
export function compareByProductCodeUnique(aCode: string, bCode: string): number {
  const a = aCode.trim();
  const b = bCode.trim();

  const slashA = /^(\d+)\/(\d+)$/.exec(a);
  const slashB = /^(\d+)\/(\d+)$/.exec(b);
  if (slashA != null && slashB != null) {
    const aArticle = Number(slashA[1]);
    const bArticle = Number(slashB[1]);
    if (aArticle !== bArticle) return aArticle - bArticle;

    const aPiece = Number(slashA[2]);
    const bPiece = Number(slashB[2]);
    return aPiece - bPiece;
  }

  return UNIQUE_CODE_COLLATOR.compare(a, b);
}

export function sortByProductCodeUnique<T extends { productCodeUnique?: string | null }>(
  items: T[],
): T[] {
  return [...items].sort((a, b) =>
    compareByProductCodeUnique(a.productCodeUnique ?? '', b.productCodeUnique ?? ''),
  );
}
